/**
 * Centralized design tokens for the SwiftaGo admin dashboard.
 *
 * Historically brand colors were redefined inline in FancyAppBar, RichNavDrawer,
 * Home, etc. This module is the single source of truth — import from here instead
 * of hardcoding hex values so a brand change is a one-line edit.
 */

export const tokens = {
  color: {
    // Brand — navy + white theme (flat, no gradients/glass)
    brand: '#13315C',       // Primary navy
    brandDark: '#0B2545',   // Deep navy (app bar / sidebar ink)
    brandAccent: '#2563EB', // Interactive blue accent

    // Semantic
    indigo: '#6366f1',
    amber: '#f59e0b',
    red: '#ef4444',
    green: '#10b981',
    purple: '#8b5cf6',
    slate: '#94a3b8',

    // Surfaces / backgrounds
    appBg: '#f4f6fa',
    surfaceAlt: '#f1f5f9',
    surface: '#ffffff',
    inkDark: '#0f172a',
    inkPanel: '#23272f',

    // Sidebar (white nav with navy accents)
    navText: '#1f2d4d',        // default nav item text
    navActiveBg: '#e8eef7',    // active item background tint
    navHoverBg: '#f1f5f9',     // hover background

    // Text
    textPrimary: '#0f172a',
    textSecondary: '#475569',
    textMuted: '#94a3b8',

    // Borders
    border: '#e2e8f0',
  },

  radius: {
    sm: 6,
    md: 10,
    lg: 16,
    pill: 999,
  },

  spacing: {
    base: 8,
  },

  font: {
    family: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },

  layout: {
    appBarHeight: 64,
    drawerWidth: 235,
  },
} as const;

export type Tokens = typeof tokens;
